const vapewholesaleshop = {
    id: 'vapewholesaleshop',
    publicSiteName: 'Vape Wholesale Shop',
    branch: process.env.NEXT_PUBLIC_SHOP_BRANCH,
    siteUrl: process.env.NEXT_PUBLIC_SITE_URL,
    googleVerification: process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION,
    gaId: process.env.NEXT_PUBLIC_GA_ID,
    theme: {
        colors: {
            primary: '#a38549',
            secondary: '#373733',
            color1: '#ab926e',
        },
        fonts: {
            body: 'var(--font-sans)',
            heading: 'var(--font-heading)',
        },
        radius: '4px',
        header: {
            layout: 'classic',
            dark: false,
            sticky: true,
            showSearch: true,
            showAccount: true,
            showWishlist: true,
            showAnnouncementBar: true,
            transparent: false,
        }
    },
    assets: {
        favicon: '/vapewholesaleshop/favicon.ico',
        logo: '/vapewholesaleshop/logo.png',
    },
    features: {
        rewards: true,
        subscriptions: true,
    },
}

export default vapewholesaleshop